// @ts-strict

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IChosenSortValue, IPagination } from '@app/core/models/core-models';

@Component({
  selector: 'app-display-options',
  templateUrl: './display-options.component.html',
  styleUrls: ['./display-options.component.scss']
})
export class DisplayOptionsComponent {
  @Input() page?: number;
  @Input() pageSize?: number;
  @Input() numberOfItems?: IChosenSortValue;
  @Input() pagination?: IPagination;
  @Input() onlyNumbers = false;
  @Input() disabled = false;
  @Input() showItemsPerPage = true;
  @Input() positionsStart?: number;
  @Input() positionsEnd?: number;
  @Input() valuesForDropdown: IChosenSortValue[] = [];
  @Output() emitPageChange = new EventEmitter<number>();

  @Output() emitItemsPerPageChange = new EventEmitter<IChosenSortValue>();

  public pageChange(page: number): void {
    this.emitPageChange.emit(page);
  }

  public itemsPerPageHandler(chosenValue: IChosenSortValue): void {
    this.emitItemsPerPageChange.emit(chosenValue);
  }
}
